/**
 * The HTTP endpoint for one operation: `?op=<operationName>` first, then any `urlParams` the caller put
 * in the operation's context. Empty values are left out. The backend reads the operation from the body
 * and ignores the query string; it is there for DevTools and the Traefik access log.
 */
export function operationUri(
  baseUri: string,
  operationName: string | undefined,
  urlParams?: Record<string, string | number | undefined | null>,
): string {
  const params = new URLSearchParams();
  if (operationName) params.set("op", operationName);
  for (const [key, value] of Object.entries(urlParams ?? {})) {
    if (value !== undefined && value !== null && value !== "") params.set(key, String(value));
  }
  const query = params.toString();
  return query ? `${baseUri}?${query}` : baseUri;
}
